/*VIDEO POSTER */
window.addEventListener('DOMContentLoaded', () => {
  $('.play-video').on('click', function(ev) {
    // If you use this function, be sure to wrapp the parent which contains video and poster + img with 'video-container' class name
    var container = $(ev.currentTarget).closest('.video-container');

    // handle video visibility
    var video = $(container).find('.video');
    $(video).addClass('opacity-100').removeClass('opacity-0');
    $(video)[0].play();

    // handle poster visibility
    var poster = $(container).find('.poster-container');
    $(poster).addClass('opacity-0').addClass('hidden');

    // handle img visibility
    var img = $(container).find('poster-container img');
    $(img).addClass('opacity-0').addClass('hidden');

    ev.preventDefault();
  });

});
